import React, { useEffect, useState } from "react";
import ProgressBar from "../ProgressBar/ProgressBar";
function ProfessionalSkills() {
  const [height, setHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => setHeight(window.innerHeight);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <>
      <div className="container p-3 mb-5 bg-body rounded">
        <div className="section-title" style={{ marginBottom: "-2rem" }}>
          <h2>Professional Skills</h2>
        </div>
        <div className="card-body">
          <ProgressBar
            label="REACT"
            backgroundColor="lightblue"
            visualParts={[
              {
                percentage: "75%",
                color: "#006aff",
              },
            ]}
          />
          <ProgressBar
            label="Node.Js"
            backgroundColor="lightblue"
            visualParts={[
              {
                percentage: "72%",
                color: "#006aff",
              },
            ]}
          />
          <ProgressBar
            label="SpringBoot"
            backgroundColor="lightblue"
            visualParts={[
              {
                percentage: "73%",
                color: "#006aff",
              },
            ]}
          />
          <ProgressBar
            label="JAVA"
            backgroundColor="lightblue"
            visualParts={[
              {
                percentage: "71%",
                color: "#006aff",
              },
            ]}
          />
          <ProgressBar
            label="PYTHON"
            backgroundColor="lightblue"
            visualParts={[
              {
                percentage: "70%",
                color: "#006aff",
              },
            ]}
          />
          <ProgressBar
            label="HTML, CSS"
            backgroundColor="lightblue"
            visualParts={[
              {
                percentage: "73%",
                color: "#006aff",
              },
            ]}
          />
        </div>
      </div>
    </>
  );
}

export default ProfessionalSkills;
